import { render, staticRenderFns } from "./InfoAssignmentButton.vue?vue&type=template&id=7f42a70d&scoped=true"
import script from "./InfoAssignmentButton.vue?vue&type=script&lang=js"
export * from "./InfoAssignmentButton.vue?vue&type=script&lang=js"
import style0 from "./InfoAssignmentButton.vue?vue&type=style&index=0&id=7f42a70d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f42a70d",
  null
  
)

export default component.exports